import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx";
import { useTranslation } from 'react-i18next';
import "../customerMaster/customerListing.css";
import "./reports.css";
import { useReportCards } from "../shared/reportCards";

const MonthWiseRevenueReport = () => {
    const { t } = useTranslation(['reports', 'common']);
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const gridRef = useRef();
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [leaseStatus, setLeaseStatus] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        unitNo: "",
        leaseNo: "",
        tenant: "",
        status: "",
        leaseStart: "",
        leaseEnd: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();
        const fromDate = new Date(today.getFullYear(), 0, 1);
        const toDate = new Date(today.getFullYear(), 11, 31);

        setFormData((prev) => ({
            ...prev,
            leaseStart: formatDate(fromDate),
            leaseEnd: formatDate(toDate),
        }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchLeaseNos,LRAgreeSearchCustomers,LRAgreeSearchStatus,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const addAllOption = (list) => [{ value: 'All', text: 'All' }, ...list || []];
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
            setLeaseList(addAllOption(res?.data?.dropdowns?.LeaseNo));
            setLeaseStatus(addAllOption(res?.data?.dropdowns?.LRAgreeSearchStatus));
            setTanentList(res?.data?.dropdowns?.LRAgreeSearchCustomers || []);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("monthWiseRevenueReportRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("monthWiseRevenueReportRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("monthWiseRevenueReportRequest.Status", formData?.status?.label || "All");
            params.append("monthWiseRevenueReportRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("monthWiseRevenueReportRequest.CustomerNo", formData?.tenant?.value?.value || "All");
            params.append("monthWiseRevenueReportRequest.LeaseStart", formData?.leaseStart || "");
            params.append("monthWiseRevenueReportRequest.LeaseEnd", formData?.leaseEnd || "");
            const res = await apiService.getApiParamater("REPORT_MONTH_WISE_REVENUE", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("monthWiseRevenueReportRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("monthWiseRevenueReportRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("monthWiseRevenueReportRequest.Status", formData?.status?.label || "All");
            params.append("monthWiseRevenueReportRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("monthWiseRevenueReportRequest.CustomerNo", formData?.tenant?.value?.value || "All");
            params.append("monthWiseRevenueReportRequest.LeaseStart", formData?.leaseStart || "");
            params.append("monthWiseRevenueReportRequest.LeaseEnd", formData?.leaseEnd || "");
            const res = await apiService.getApiParamater("REPORT_MONTH_WISE_REVENUE", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false);
        }
    }
    const monthFormatter = (params) => (params?.value || params?.value === 0) ? Number(params.value).toFixed(currencyPrecision?.decimalNumbers || 2) : "";
    const columnDefs = [
        { headerName: t('reports:monthWiseRevenue.columns.propertyNo'), field: "propertyNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left" },
        { headerName: t('reports:monthWiseRevenue.columns.propertyName'), field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left" },
        { headerName: t('reports:monthWiseRevenue.columns.unitNo'), field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: t('reports:monthWiseRevenue.columns.unitType'), field: "unitType", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: t('reports:monthWiseRevenue.columns.status'), field: "status", filter: true, floatingFilter: true, suppressMovable: true, width: 110 },
        { headerName: t('reports:monthWiseRevenue.columns.leaseNo'), field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:monthWiseRevenue.columns.tenantNo'), field: "tenantNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:monthWiseRevenue.columns.tenantName'), field: "tenantName", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: t('reports:monthWiseRevenue.columns.tenantType'), field: "tenantType", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        {
            headerName: t('reports:monthWiseRevenue.columns.leaseStartDate'), field: "leaseStartDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: (params) => params?.value ? moment(params.value).format("DD-MMM-YYYY") : ""
        },
        {
            headerName: t('reports:monthWiseRevenue.columns.leaseExpiryDate'), field: "leaseExpiryDate", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: (params) => params?.value ? moment(params.value).format("DD-MMM-YYYY") : ""
        },
        { headerName: t('reports:monthWiseRevenue.columns.years'), field: "years", filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: t('reports:monthWiseRevenue.columns.contractedAmount'), field: "contractedAmount", filter: true, floatingFilter: true, suppressMovable: true, width: 150, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.jan'), field: "january", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.feb'), field: "february", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.mar'), field: "march", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.apr'), field: "april", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.may'), field: "may", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.jun'), field: "june", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.jul'), field: "july", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.aug'), field: "august", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.sep'), field: "september", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.oct'), field: "october", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.nov'), field: "november", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
        { headerName: t('reports:monthWiseRevenue.columns.dec'), field: "december", filter: true, floatingFilter: true, suppressMovable: true, width: 110, valueFormatter: monthFormatter },
    ]
    const handleClearFilters = () => {
        setUnitList([])
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today.getFullYear(), 0, 1);
        const toDate = new Date(today.getFullYear(), 11, 31);
        setFormData({
            property: { label: "All", value: "All" },
            unitNo: "",
            leaseNo: "",
            tenant: "",
            status: "",
            leaseStart: formatDate(fromDate),
            leaseEnd: formatDate(toDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const loadTenantOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "Property No", dataKey: "propertyNo" },
        { header: "Property Name", dataKey: "propertyName" },
        { header: "Unit No", dataKey: "unitNo" },
        { header: "Status", dataKey: "status" },
        { header: "Lease No", dataKey: "leaseNo" },
        { header: "Tenant Name", dataKey: "tenantName" },
        { header: "Lease Start Date", dataKey: "leaseStartDate" },
        { header: "Lease Expiry Date", dataKey: "leaseExpiryDate" },
        { header: "Contracted Amount", dataKey: "contractedAmount" },
        { header: "Jan", dataKey: "january" },
        { header: "Feb", dataKey: "february" },
        { header: "Mar", dataKey: "march" },
        { header: "Apr", dataKey: "april" },
        { header: "May", dataKey: "may" },
        { header: "Jun", dataKey: "june" },
        { header: "Jul", dataKey: "july" },
        { header: "Aug", dataKey: "august" },
        { header: "Sep", dataKey: "september" },
        { header: "Oct", dataKey: "october" },
        { header: "Nov", dataKey: "november" },
        { header: "Dec", dataKey: "december" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Month Wise Revenue Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated on: ${moment().format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 7,
                cellPadding: 4,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Month Wise Revenue Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const excelData = exportData.map(item => {
            const row = {};
            exportColumns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Month Wise Revenue");
        XLSX.writeFile(workbook, "Month Wise Revenue Report.xlsx");
    };
    const cards = useReportCards({
        label: "Leases in view",
        rowData,
        exportData: exportData,
        pagination,
        fields: [["status",2],["tenantType",2]],
    });

    return (
        <div className="cl-page rpt-legacy">
            <div className="cl-titlebar">
                <div className="cl-title">
                    <h1>{t('reports:monthWiseRevenue.title')}</h1>
                    <p>{t('reports:monthWiseRevenue.description', 'Revenue by month for the selected period.')}</p>
                </div>
            </div>
            {cards.strip}
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">{t('common:searchParameters')}</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:property')} </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:unitNo')} </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:leaseNo')}</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseNo', value: selectedOption })}
                                    options={leaseList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:status')}</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.status}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
                                    options={leaseStatus?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex" style={{ gridColumn: "span 2" }}>
                                <label htmlFor="validationCustom18" className="form-label">{t('common:tenant')}</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        control: base => ({ ...base, fontSize: "12px" }),
                                        singleValue: base => ({ ...base, fontSize: "12px" }),
                                        input: base => ({ ...base, fontSize: "12px" }),
                                        placeholder: base => ({ ...base, fontSize: "12px" }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            fontSize: "12px",
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenant}
                                    loadOptions={loadTenantOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenant", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-end mt-3" style={{ maxWidth: '1200px', margin: 'auto', gap: '20px' }}>
                            <div className="d-flex flex-wrap" style={{ gap: '20px' }}>
                                <div className="d-flex">
                                    <label className="form-label">{t('reports:leaseStart')}</label>
                                    <DatePicker
                                        selected={formData.leaseStart}
                                        onChange={(date) => handleDateChange({ name: 'leaseStart', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label className="form-label w-0">{t('reports:leaseEnd')}</label>
                                    <DatePicker
                                        selected={formData.leaseEnd}
                                        onChange={(date) => handleDateChange({ name: 'leaseEnd', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">{t('common:search')}</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">{t('common:reset')}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>{t('common:loading')}</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">{t('reports:monthWiseRevenue.title')}</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                {t('reports:exportAsPdf')}
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                {t('reports:exportAsExcel')}
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={cards.shownRows}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            {!cards.active && <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />}
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default MonthWiseRevenueReport;
